import React from 'react'
import CategoryAnalysisContainer from '../../components/CategoryAnalysis/CategoryAnalysisContainer'

import SEO from '../../components/Common/SEO'
import { PAGE_SEO, STRUCTURED_DATA } from '../../config/seoConfig'
import { generateCanonicalUrl } from '../../utils/seoUtils'

const CategoryAnalysis = () => {
  return (
    <React.Fragment>
      <SEO
        title={PAGE_SEO.categoryAnalysis.title}
        description={PAGE_SEO.categoryAnalysis.description}
        keywords={PAGE_SEO.categoryAnalysis.keywords}
        canonical={generateCanonicalUrl('/category-analysis')}
        robots={PAGE_SEO.categoryAnalysis.robots}
        structuredData={[STRUCTURED_DATA.organization, STRUCTURED_DATA.website]}
      />
      <CategoryAnalysisContainer />
    </React.Fragment>
  )
}

export default CategoryAnalysis